import React, { useState, useEffect, useContext } from 'react'
import Container from '@mui/material/Container'
import _ from 'lodash'
import { authContext } from '../../../contexts/AuthContext'
import Grid from '@mui/material/Grid'
import 'react-block-ui/style.css'
import {
  listWorkspacesByClientId,
  listWorkspaceSubcategories
} from '../../../services/workspaces'
import MisDocumentosProvider, { misDocumentosContext } from '../../../contexts/MisDocumentosContext'
import { apiUrl } from '../../../config/api'
import MisDocumentosDirectory from './MisDocumentosDirectory'

const MisDocumentosContent = ({ clientId, userId, subcategories }) => {
  const { setId } = useContext(misDocumentosContext)

  useEffect(() => {
    if (clientId) setId(clientId)
  }, [clientId, setId])

  return (
    <Container maxWidth='lg' sx={{ mt: 4, mb: 4 }}>
      <Grid
        container
        spacing={{ xs: 2, md: 3 }}
        columns={{ xs: 6, sm: 6, md: 12 }}
      >
        <Grid item xs={12}>
          <MisDocumentosDirectory
            userId={userId}
            subcategories={subcategories}
          />
        </Grid>
      </Grid>
    </Container>
  )
}

export const MisDocumentosIndex = (props) => {
  // Pagina de navegacion de documentos del cliente, pagina para usuarios clientes
  const { auth } = useContext(authContext)

  const [client, setClient] = useState({})
  const [subcategories, setSubcategories] = useState([])

  useEffect(() => {
    fetchClientOrPersonByUser()
  }, [])

  const fetchClientOrPersonByUser = async () => {
    let url = apiUrl('GetClientOrPersonByUser')
    fetch(`${url}&userId=${auth.user.id}`)
      .then((response) => response.json())
      .then((data) => {
        setClient(data)
        fetchClientCategories(data.id)
      })
  }

  const fetchClientCategories = async (clientId) => {
    /* Get subcategories by workspace */
    let workspaces = await listWorkspacesByClientId(clientId)
    let subcategories = []
    workspaces.map(async (workspace) => {
      let list = await listWorkspaceSubcategories(workspace.workspace_id)
      subcategories.push({
        workspace: workspace,
        subcategories: list
      })
    })

    setSubcategories(subcategories)
  }

  if (_.isEmpty(client)) {
    return <div />
  }

  return (
    <MisDocumentosProvider>
      <MisDocumentosContent
        clientId={client.id}
        userId={auth.user.id}
        subcategories={subcategories}
      />
    </MisDocumentosProvider>
  )
}
